export default __webpack_public_path__ + "static/media/paid.b061d713.svg";